import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, Container } from "react-bootstrap";

class Header extends Component {
  handleScroll = (val) => {
    const e = document.querySelector(`.${val}-section`);
    console.log(e.offsetTop, val);
    window.scrollTo({ top: e.offsetTop, behavior: "smooth" });
  };
  render() {
    return (
      <Navbar
        style={{ backgroundColor: "inherit", fontSize: "2rem", color: "black" }}
        expand="lg"
      >
        <Container>
          <Navbar.Brand href="#home">
            <img
              src="mylogo.png"
              className="d-inline-block align-top logo"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                onClick={() => this.handleScroll("about")}
                style={{ color: "white", fontSize: "2.5rem" }}
                href=""
              >
                About
              </Nav.Link>
              <Nav.Link
                onClick={() => this.handleScroll("education")}
                style={{ color: "white", fontSize: "2.5rem" }}
                href=""
              >
                Education
              </Nav.Link>
              <Nav.Link
                onClick={() => this.handleScroll("skills")}
                style={{ color: "white", fontSize: "2.5rem" }}
                href=""
              >
                Skills
              </Nav.Link>
              <Nav.Link
                onClick={() => this.handleScroll("project")}
                style={{ color: "white", fontSize: "2.5rem" }}
                href=""
              >
                Projects
              </Nav.Link>
              {/* <Nav.Link
                onClick={() => this.handleScroll("experience")}
                style={{ color: "white" }}
                href=""
              >
                Experience
              </Nav.Link> */}
              <Nav.Link
                onClick={() => this.handleScroll("contactme")}
                style={{ color: "white", fontSize: "2.5rem" }}
                href=""
              >
                Contact Me
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Header;
